<template>
  <div>
    <!-- Cabeçalho -->
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h5 class="mb-0">Questões de Avaliação</h5>
      <b-button
        v-if="hasPermission('adicionar_parametrosavaliacoes_questoes')"
        variant="primary"
        class="d-flex align-items-center"
        @click="irParaCadastro"
      >
        <i class="bi bi-plus-circle-fill mr-2" title="Novo Cadastro"></i>
      </b-button>
    </div>

    <!-- Filtros -->
    <div class="d-flex align-items-center gap-3 mb-3">
      <input
        v-model="filters.categoria"
        placeholder="Filtrar por categoria"
        class="form-control"
        @input="filtrar"
      />
      <input
        v-model="filters.bloco"
        placeholder="Filtrar por bloco"
        class="form-control"
        @input="filtrar"
      />
      <input
        v-model="filters.questao"
        placeholder="Filtrar por questão"
        class="form-control"
        @input="filtrar"
      />
      <select
        v-model="filters.ativo"
        @change="filtrar"
        class="form-select"
        style="width: auto;"
      >
        <option value="">Filtrar por status</option>
        <option value="true">Ativo</option>
        <option value="false">Inativo</option>
      </select>
      <b-button
        variant="secondary"
        @click="limparFiltros"
        class="d-flex align-items-center justify-content-center"
      >
        <i class="bi bi-funnel mr-2" title="Limpar Filtro"></i>
      </b-button>
    </div>

    <!-- Tabela customizada -->
    <table class="table table-striped table-hover">
      <thead>
        <tr>
          <th>
            <button class="btn btn-link p-0" @click="changeSort('id')">
              # {{ arrow('id') }}
            </button>
          </th>
          <th>
            <button class="btn btn-link p-0" @click="changeSort('categoria_nome')">
              Categoria {{ arrow('categoria_nome') }}
            </button>
          </th>
          <th>
            <button class="btn btn-link p-0" @click="changeSort('bloco_nome')">
              Bloco {{ arrow('bloco_nome') }}
            </button>
          </th>
          <th>
            <button class="btn btn-link p-0" @click="changeSort('questao')">
              Questão {{ arrow('questao') }}
            </button>
          </th>
          <th>
            <button class="btn btn-link p-0" @click="changeSort('tipo_dado')">
              Tipo {{ arrow('tipo_dado') }}
            </button>
          </th>
          <th>
            <button class="btn btn-link p-0" @click="changeSort('ativo')">
              Ativo {{ arrow('ativo') }}
            </button>
          </th>
          <!-- <th>
            <button class="btn btn-link p-0" @click="changeSort('criado_em')">
              Criado {{ arrow('criado_em') }}
            </button>
          </th>
          <th>
            <button class="btn btn-link p-0" @click="changeSort('atualizado_em')">
              Atualizado {{ arrow('atualizado_em') }}
            </button>
          </th> -->
          <th class="text-end">Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="q in questoes" :key="q.id">
          <td>{{ q.id }}</td>
          <td>{{ q.categoria_nome || '—' }}</td>
          <td>{{ q.bloco_nome || '—' }}</td>
          <td>{{ q.questao || '—' }}</td>
          <td>{{ q.tipo_dado || '—' }}</td>
          <td>{{ q.ativo ? 'Sim' : 'Não' }}</td>
          <!-- <td>{{ formatDate(q.criado_em) }}</td>
          <td>{{ formatDate(q.atualizado_em) }}</td> -->
          <td class="text-end">
            <i
              v-if="hasPermission('detalhar_parametrosavaliacoes_questoes')"
              class="bi bi-eye-fill text-primary mx-2"
              title="Detalhar"
              @click="detalhar(q.id)"
            ></i>
            <i
              v-if="hasPermission('alterar_parametrosavaliacoes_questoes')"
              class="bi bi-pencil-fill text-warning mx-2"
              title="Editar"
              @click="editar(q.id)"
            ></i>
            <i
              v-if="hasPermission('excluir_parametrosavaliacoes_questoes')"
              class="bi bi-trash-fill text-danger mx-2"
              title="Excluir"
              @click="excluir(q.id)"
            ></i>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- Paginação -->
    <div class="d-flex justify-content-between align-items-center mt-3">
      <div>
        Mostrando {{ startRow }} a {{ endRow }} de {{ totalItems }} registros
      </div>
      <div class="d-flex align-items-center" style="gap: .5rem;">
        <b-form-select
          v-model="limit"
          :options="pageOptions.map(n => ({ value: n, text: n + ' / página' }))"
          size="sm"
          style="width: 6rem"
          @change="changeLimit"
        />
      </div>
      <div class="d-flex align-items-center">
        <b-pagination
          v-model="page"
          :per-page="limit"
          :total-rows="totalItems"
          size="sm"
          limit="5"
          @input="load"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, watch } from 'vue'
import { useRouter } from 'vue-router'
import axios from '@/services/axios'
import { BButton, BPagination, BFormSelect } from 'bootstrap-vue-next'
import { useSortableTable } from '@/utils/useSortableTable'
import { usePermissions } from '@/composables/usePermissions'

const router = useRouter()
const { fetchPermissions, hasPermission } = usePermissions()

const {
  items: questoes,
  totalItems,
  page,
  limit,
  filters,
  load,
  sort: changeSort,
  arrow
} = useSortableTable(
  `/configuracoes/parametros-avaliacoes/questoes`,
  { key: 'questao', order: 'asc' }
)

const pageOptions = ref([10, 15, 20, 25, 50])
const startRow   = computed(() => (page.value - 1) * limit.value + 1)
const endRow     = computed(() => Math.min(page.value * limit.value, totalItems.value))

// function formatDate(dt) {
//   return dt ? new Date(dt).toLocaleDateString('pt-BR') : ''
// }

function filtrar() {
  page.value = 1
  load()
}
function limparFiltros() {
  filters.value.categoria = ''
  filters.value.bloco     = ''
  filters.value.questao   = ''
  filters.value.ativo     = ''
  page.value = 1
  load()
}
function changeLimit() {
  page.value = 1
  load()
}

function irParaCadastro() {
  router.push('/configuracoes/parametros-avaliacoes/questoes/novo')
}
function detalhar(id) {
  router.push(`/configuracoes/parametros-avaliacoes/questoes/${id}/detalhar`)
}
function editar(id) {
  router.push(`/configuracoes/parametros-avaliacoes/questoes/${id}`)
}
async function excluir(id) {
  if (confirm('Deseja excluir esta questão?')) {
    await axios.delete(`/configuracoes/parametros-avaliacoes/questoes/${id}`)
    load()
  }
}

watch(page, () => {
  load()
})

watch(limit, () => {
  page.value = 1
  load()
})


onMounted(async () => {
  await fetchPermissions()
  filters.categoria = ''
  filters.bloco     = ''
  filters.questao   = ''
  filters.ativo     = ''
  load()
})
</script>

<style scoped>
:deep(.pagination.pagination-sm .page-link) {
  line-height: 1;
  font-size: 0.8rem !important;
  border-radius: 0 !important;
}
.table-hover tr:hover { background-color: var(--bs-light); }
</style>
